export default "__VITE_ASSET__BtAVEq9L__"